import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { events } from 'growth-payments-core/usage-tracker/events';
import { track } from 'growth-payments-core/usage-tracker/track';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CANCEL_MODAL_ACTION;
(function (CANCEL_MODAL_ACTION) {
  CANCEL_MODAL_ACTION["GoBack"] = "cancelModalGoBackButtonClicked";
  CANCEL_MODAL_ACTION["Confirm"] = "cancelModalConfirmButtonClicked";
})(CANCEL_MODAL_ACTION || (CANCEL_MODAL_ACTION = {}));
export const TEST_IDS = {
  CANCEL_MODAL_CONFIRM_BUTTON: 'cancel-modal-confirm-button'
};
export const trackCancelModalInteraction = action => {
  track(events.paymentSettingsInteraction, {
    action,
    location: 'cancel-modal'
  });
};
const CancelModal = ({
  onConfirm,
  onGoBack
}) => /*#__PURE__*/_jsxs(Modal, {
  use: "conversational",
  width: 500,
  children: [/*#__PURE__*/_jsx(DialogHeader, {
    children: /*#__PURE__*/_jsx(Text, {
      as: "h4",
      textAlign: "start",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CancelModal.header"
      })
    })
  }), /*#__PURE__*/_jsx(DialogBody, {
    paddingBlockEnd: "400",
    children: /*#__PURE__*/_jsx(Text, {
      as: "p",
      textAlign: "start",
      paddingBlockStart: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CancelModal.description"
      })
    })
  }), /*#__PURE__*/_jsxs(DialogFooter, {
    children: [/*#__PURE__*/_jsx(Button, {
      "data-test-id": TEST_IDS.CANCEL_MODAL_CONFIRM_BUTTON,
      onClick: () => {
        trackCancelModalInteraction(CANCEL_MODAL_ACTION.Confirm);
        onConfirm();
      },
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CancelModal.cancel"
      })
    }), /*#__PURE__*/_jsx(Button, {
      onClick: () => {
        trackCancelModalInteraction(CANCEL_MODAL_ACTION.GoBack);
        onGoBack();
      },
      use: "tertiary-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CancelModal.goBack"
      })
    })]
  })]
});
export default CancelModal;